import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, contentChild, inject, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { StorageService } from '@cosmos/angular/utils';
import { SelectButtonModule } from 'primeng/selectbutton';


@Component({
    selector: 'cosmos-table-list-selector',
    imports: [SelectButtonModule, FormsModule, NgTemplateOutlet],
    providers: [],
    templateUrl: 'table-list-selector.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: `
        .p-selectbutton {
            border: 1px solid var(--p-divider-border-color);
        }
    `
})
export class TableListSelectorComponent {
    private readonly storageService = inject(StorageService);

    currentGroup: string = this.storageService.getItem('groupDisplay') ?? 'cards';

    readonly options: any[] = [
        { icon: 'fa-solid fa-grip', group: 'cards' },
        { icon: 'fa-solid fa-list', group: 'table' }
    ];

    readonly cardContent = contentChild<TemplateRef<unknown>>('cards');
    readonly tableContent = contentChild<TemplateRef<unknown>>('table');

    updateStorage($event: any) {
        this.storageService.setItem('groupDisplay', $event.value);
    }
}
